/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RolesManagementComponent} from './roles-management.component';
import {NgbModule, NgbTooltipModule, NgbTypeaheadModule} from '@ng-bootstrap/ng-bootstrap';
import {ReactiveFormsModule} from '@angular/forms';
import {UsersTableComponent} from './users-table/users-table.component';
import {SelectInTableModule} from '../../shared/select-in-table/select-in-table.module';
import {PipesModule} from '../../shared/pipes/pipes.module';
import {LoadingSpinnerModule} from '../../shared/loading/loading-spinner/loading-spinner.module';
import {UserDisplayPipe} from '../../shared/pipes/user-display/user-display.pipe';
import {PaginationModule} from '../../shared/pagination/pagination.module';
import {CodeFilterModule} from '../../shared/filter/code-filter/code-filter.module';
import {InputFilterModule} from '../../shared/filter/input-filter/input-filter.module';
import {TooltipModule} from '../../shared/tooltip/tooltip.module';
import {InputModule} from '../../shared/input/input.module';
import {TechnicianGroupsTooltipContentComponent} from './users-table/technician-groups-tooltip/technician-groups-tooltip-content.component';
import {ChipSelectorModule} from '../../shared/chip-selector/chip-selector.module';

@NgModule({
    declarations: [
        RolesManagementComponent,
        UsersTableComponent,
        TechnicianGroupsTooltipContentComponent
    ],
    imports: [
        CommonModule,
        NgbTypeaheadModule,
        ReactiveFormsModule,
        SelectInTableModule,
        PipesModule,
        LoadingSpinnerModule,
        PaginationModule,
        CodeFilterModule,
        InputFilterModule,
        NgbTooltipModule,
        TooltipModule,
        InputModule,
        NgbModule,
        ChipSelectorModule
    ],
    providers: [
        UserDisplayPipe
    ],
    exports: [RolesManagementComponent]
})

export class RolesManagementModule {
}
